import React from 'react';

import { CheckboxGroup } from 'src/components/molecules/CheckboxGroup/CheckboxGroup';
import type { UIFacetOption } from 'src/components/types/UIFacet';
import type { FacetOptionsProps } from './types';
import { formatOptionCount } from './utils/formatOptionCount';

const HIDE_ZERO_COUNT_OPTIONS_THRESHOLD = 10;

export const FacetOptionsMulti = ({ facet }: FacetOptionsProps) => {
  const getActiveOrNonZeroCountOptions = (options: UIFacetOption[]) => {
    return options.filter((option) => (option.count ?? 0) > 0 || option.active);
  };
  const facetOptions =
    facet.options.length > HIDE_ZERO_COUNT_OPTIONS_THRESHOLD
      ? getActiveOrNonZeroCountOptions(facet.options)
      : facet.options;

  return (
    <CheckboxGroup
      accessibleLabel={facet.title}
      checkboxData={facetOptions.map(({ active, count, href, title, value }) => ({
        checked: active,
        disabled: !active && count === 0,
        href,
        labelText: title,
        value: value as string,
        secondaryLabelText: formatOptionCount(count),
      }))}
      hideLabel
      name={facet.key}
    />
  );
};
